<div *ngIf="isOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
  <div
    class="bg-white dark:bg-slate-900 rounded-[28px] shadow-2xl w-full max-w-4xl overflow-hidden flex flex-col max-h-[92vh] border border-transparent dark:border-slate-800">

    <!-- Header -->
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-start justify-between gap-4">
      <div>
        <h3 class="text-xl font-extrabold text-slate-800 dark:text-white">Import Excel บัตรจอดรถ</h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">
          Site: <span class="font-bold text-slate-700 dark:text-slate-200">{{ siteName || siteId || '-' }}</span>
        </p>
        <div class="mt-3 flex items-center gap-2 text-xs font-bold">
          <span class="px-2.5 py-1 rounded-full"
            [class.bg-amber-100]="step === 1" [class.text-amber-700]="step === 1"
            [class.bg-slate-100]="step !== 1" [class.text-slate-500]="step !== 1">1. ตั้งค่าบัตร</span>
          <span class="text-slate-300">→</span>
          <span class="px-2.5 py-1 rounded-full"
            [class.bg-amber-100]="step === 2" [class.text-amber-700]="step === 2"
            [class.bg-slate-100]="step !== 2" [class.text-slate-500]="step !== 2">2. ไฟล์ Excel</span>
          <span class="text-slate-300">→</span>
          <span class="px-2.5 py-1 rounded-full"
            [class.bg-amber-100]="step === 3" [class.text-amber-700]="step === 3"
            [class.bg-slate-100]="step !== 3" [class.text-slate-500]="step !== 3">3. ยืนยัน</span>
        </div>
      </div>
      <button type="button" (click)="close()"
        class="w-10 h-10 rounded-full flex items-center justify-center text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6 overflow-y-auto custom-scrollbar flex-1">

      <!-- Step 1 -->
      <div *ngIf="step === 1" class="space-y-4">
        <p class="text-sm text-slate-500 dark:text-slate-400">
          เลือกตั้งค่าบัตรที่ใช้ร่วมกันทุกแถวในไฟล์ก่อน — ยังไม่สามารถอัปโหลด Excel ได้จนกว่าจะครบ
        </p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Client -->
          <div class="relative">
            <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">Client *</label>
            <input type="text" [(ngModel)]="clientSearchText" (focus)="isClientDropdownOpen = true"
              (blur)="isClientDropdownOpen = false"
              placeholder="ค้นหาร้าน..."
              class="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium" />
            <div *ngIf="isClientDropdownOpen"
              class="absolute z-20 mt-1 w-full max-h-48 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg">
              <button type="button" *ngFor="let c of filteredClients"
                (mousedown)="selectClient(c)"
                class="w-full text-left px-3 py-2 text-sm hover:bg-amber-50 dark:hover:bg-amber-900/20">
                {{ c.name }}
              </button>
            </div>
          </div>

          <!-- Card type -->
          <div class="relative">
            <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">ประเภทบัตร *</label>
            <input type="text" [(ngModel)]="searchCardTypeText" (focus)="isCardTypeDropdownOpen = true"
              (blur)="isCardTypeDropdownOpen = false"
              placeholder="ค้นหาประเภทบัตร..."
              class="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium" />
            <div *ngIf="isCardTypeDropdownOpen"
              class="absolute z-20 mt-1 w-full max-h-48 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg">
              <button type="button" *ngFor="let t of filteredCardTypes"
                (mousedown)="selectCardType(t)"
                class="w-full text-left px-3 py-2 text-sm hover:bg-amber-50 dark:hover:bg-amber-900/20">
                {{ t.name }}
              </button>
            </div>
          </div>

          <!-- Subscription -->
          <div class="relative">
            <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">Subscription *</label>
            <input type="text" [(ngModel)]="searchSubscriptionText" (focus)="isSubscriptionDropdownOpen = true"
              (blur)="isSubscriptionDropdownOpen = false"
              placeholder="ค้นหา Subscription..."
              class="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium" />
            <div *ngIf="isSubscriptionDropdownOpen"
              class="absolute z-20 mt-1 w-full max-h-48 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg">
              <button type="button" *ngFor="let s of filteredSubscriptions"
                (mousedown)="selectSubscription(s)"
                class="w-full text-left px-3 py-2 text-sm hover:bg-amber-50 dark:hover:bg-amber-900/20">
                {{ s.name }}
              </button>
            </div>
            <p *ngIf="subscriptionId > 0" class="mt-1 text-[11px] text-slate-400">
              rateId: {{ rateId || '-' }} · gateGroupId: {{ gateGroupId || '-' }}
            </p>
          </div>

          <!-- Card mode -->
          <div>
            <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">โหมดบัตร</label>
            <select [(ngModel)]="cardMode"
              class="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium">
              <option *ngFor="let m of cardModeOptions" [ngValue]="m.value">{{ m.label }}</option>
            </select>
          </div>

          <div>
            <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">วันเริ่ม *</label>
            <input type="date" [(ngModel)]="issueDate"
              class="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium" />
          </div>
          <div>
            <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">วันหมดอายุ *</label>
            <input type="date" [(ngModel)]="expireDate"
              class="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium" />
          </div>
        </div>
      </div>

      <!-- Step 2 -->
      <div *ngIf="step === 2" class="space-y-4">
        <div
          class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 p-4 text-sm">
          <div class="font-bold text-slate-700 dark:text-slate-200 mb-1">ตั้งค่าร่วม</div>
          <div class="text-slate-500 dark:text-slate-400">
            {{ selectedClientName }} · {{ selectedCardTypeName }} · {{ selectedSubscriptionName }}
            · {{ issueDate }} → {{ expireDate }}
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-3">
          <button type="button" (click)="downloadSampleExcel()"
            class="px-4 h-11 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-bold text-sm hover:border-amber-300 hover:text-amber-600 flex items-center gap-2">
            <span class="material-icons text-lg">download</span>
            ดาวน์โหลด Excel ตัวอย่าง
          </button>
          <label
            class="px-4 h-11 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold text-sm cursor-pointer flex items-center gap-2">
            <span class="material-icons text-lg">upload_file</span>
            เลือกไฟล์ Excel
            <input type="file" class="hidden" accept=".xlsx,.xls" (change)="onFileSelected($event)" />
          </label>
          <span *ngIf="selectedFileName" class="text-xs text-slate-400 font-medium truncate max-w-[220px]">
            {{ selectedFileName }}
          </span>
        </div>

        <div *ngIf="previewRows.length" class="flex flex-wrap gap-3 text-xs font-bold">
          <span class="px-2.5 py-1 rounded-full bg-slate-100 text-slate-600">ทั้งหมด {{ previewRows.length }}</span>
          <span class="px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700">พร้อม {{ validPreviewCount }}</span>
          <span class="px-2.5 py-1 rounded-full bg-rose-50 text-rose-700">มีปัญหา {{ errorPreviewCount }}</span>
        </div>

        <div *ngIf="previewRows.length"
          class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
          <div class="overflow-x-auto max-h-[320px]">
            <table class="w-full text-sm text-left">
              <thead class="bg-slate-50 dark:bg-slate-900/50 text-xs font-bold text-slate-400 uppercase sticky top-0">
                <tr>
                  <th class="px-3 py-2">แถว</th>
                  <th class="px-3 py-2">ทะเบียน</th>
                  <th class="px-3 py-2">จังหวัด</th>
                  <th class="px-3 py-2">ชื่อ</th>
                  <th class="px-3 py-2">เบอร์</th>
                  <th class="px-3 py-2">สถานะ</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                <tr *ngFor="let row of previewRows"
                  [ngClass]="{
                    'bg-rose-50/40 dark:bg-rose-950/20': !row.ok
                  }">
                  <td class="px-3 py-2 text-slate-400">{{ row.rowNumber }}</td>
                  <td class="px-3 py-2 font-mono text-xs">{{ row.licensePlate || '-' }}</td>
                  <td class="px-3 py-2">{{ row.province || '-' }}</td>
                  <td class="px-3 py-2">{{ row.name || '-' }}</td>
                  <td class="px-3 py-2 font-mono text-xs">{{ row.phone || '-' }}</td>
                  <td class="px-3 py-2">
                    <span *ngIf="row.ok" class="text-emerald-600 font-bold text-xs">OK</span>
                    <span *ngIf="!row.ok" class="text-rose-600 font-bold text-xs" [title]="row.error">{{ row.error }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <p *ngIf="!previewRows.length" class="text-sm text-slate-400 text-center py-10 border border-dashed rounded-2xl">
          ดาวน์โหลดไฟล์ตัวอย่าง กรอกข้อมูล แล้วอัปโหลดเพื่อดู preview
        </p>
      </div>

      <!-- Step 3 -->
      <div *ngIf="step === 3" class="space-y-4">
        <div class="rounded-2xl bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/40 p-4">
          <div class="font-extrabold text-slate-800 dark:text-slate-100 mb-2">ยืนยันการนำเข้า</div>
          <ul class="text-sm text-slate-600 dark:text-slate-300 space-y-1">
            <li>Client: {{ selectedClientName }}</li>
            <li>ประเภทบัตร: {{ selectedCardTypeName }}</li>
            <li>Subscription: {{ selectedSubscriptionName }}</li>
            <li>ช่วงวัน: {{ issueDate }} → {{ expireDate }}</li>
            <li>จำนวนแถวที่จะสร้าง: <span class="font-bold text-amber-700">{{ validPreviewCount }}</span></li>
          </ul>
        </div>

        <div *ngIf="importResult" class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
          <div class="px-4 py-3 bg-slate-50 dark:bg-slate-900/50 flex gap-3 text-xs font-bold">
            <span class="text-emerald-600">สำเร็จ {{ importResult.successCount }}</span>
            <span class="text-rose-600">ล้มเหลว {{ importResult.failCount }}</span>
          </div>
          <div class="overflow-x-auto max-h-[260px]">
            <table class="w-full text-sm">
              <thead class="text-xs text-slate-400 font-bold uppercase">
                <tr>
                  <th class="px-3 py-2 text-left">แถว</th>
                  <th class="px-3 py-2 text-left">ชื่อ</th>
                  <th class="px-3 py-2 text-left">ทะเบียน</th>
                  <th class="px-3 py-2 text-left">ผล</th>
                  <th class="px-3 py-2 text-left">ข้อความ</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of importResult.results" class="border-t border-slate-50 dark:border-slate-800">
                  <td class="px-3 py-2">{{ r.rowNumber || '-' }}</td>
                  <td class="px-3 py-2">{{ r.name || '-' }}</td>
                  <td class="px-3 py-2 font-mono text-xs">{{ r.licensePlate || '-' }}</td>
                  <td class="px-3 py-2">
                    <span [class.text-emerald-600]="r.ok" [class.text-rose-600]="!r.ok" class="font-bold text-xs">
                      {{ r.ok ? 'OK' : 'FAIL' }}
                    </span>
                  </td>
                  <td class="px-3 py-2 text-xs text-slate-500">{{ r.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between gap-3">
      <button type="button" (click)="step === 1 ? close() : goBack()"
        class="px-4 h-11 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold text-sm">
        {{ step === 1 ? 'ยกเลิก' : 'ย้อนกลับ' }}
      </button>

      <div class="flex items-center gap-2">
        <button *ngIf="step < 3" type="button" (click)="goNext()"
          [disabled]="step === 1 ? !canGoStep2 : !canGoStep3"
          class="px-5 h-11 rounded-xl bg-amber-400 hover:bg-amber-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold text-sm">
          ถัดไป
        </button>
        <button *ngIf="step === 3 && !importResult" type="button" (click)="confirmImport()"
          [disabled]="isImporting || !canGoStep3"
          class="px-5 h-11 rounded-xl bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-white font-bold text-sm flex items-center gap-2">
          <span *ngIf="isImporting" class="material-icons animate-spin text-base">progress_activity</span>
          {{ isImporting ? 'กำลังนำเข้า...' : 'ยืนยัน Import' }}
        </button>
        <button *ngIf="step === 3 && importResult" type="button" (click)="close()"
          class="px-5 h-11 rounded-xl bg-slate-800 dark:bg-slate-100 text-white dark:text-slate-900 font-bold text-sm">
          ปิด
        </button>
      </div>
    </div>
  </div>
</div>
